import React from 'react';
import FooterBase from './footer.base';
import { items } from './data/footer.data';
import Link from 'atomic/link';
import ras_logo from '../../../assets/images/ras_logo.svg';
import Icon from 'atomic/icon';

import './footer.desktop.scss';

const FooterDesktop: React.FC = () => (
    <FooterBase>
        <div className="container">
            <div className="footer__main">
                {
                    items.map(item => (
                        <section className="footer__main__section" key={item.label}>
                            <div className="footer__main__section__header">
                                {item.label}
                            </div>
                            <ul className="footer__main__section__list">
                                {
                                    item.items.map(link => (
                                        <li key={link.href} className="footer__main__section__list__item">
                                            <Link
                                                href={link.href}
                                                target={link.target}
                                                rel={link.rel}
                                                title={link.title}
                                                size="xs"
                                            >
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))
                                }
                            </ul>
                        </section>
                    ))
                }
            </div>
            <div className="footer__aside">
                <div className="footer__aside__top">
                    <Link
                        href="https://panel.moneteasy.pl"
                        title="Logowanie do Moneteasy"
                        rel="nofollow"
                        type="button"
                        className="footer__aside__button"
                        color="transparent-secondary"
                        size="md"
                        target="_blank"
                    >
                        <Icon name="partner" color="secondary" size={20}/>
                        Panel Partnerski
                    </Link>
                    <Link
                        href="https://partner.moneteasy.pl/skapiec"
                        title="Wiele narzędzi, jedna platforma: Moneteasy"
                        rel="nofollow"
                        type="button"
                        className="footer__aside__button"
                        color="transparent-secondary"
                        size="md"
                        target="_blank"
                    >
                        <Icon name="pie-chart" color="secondary" size={20}/>
                        Panel dla sklepów
                    </Link>
                </div>
                <div className="footer__aside__bottom">
                    <p>
                        Należymy do grupy
                    </p>
                    <div className="footer__aside__image">
                        <img
                            src={ras_logo}
                            width={100}
                            height={41}
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    </FooterBase>
);

export default FooterDesktop;
